export { default as Twitter } from './src/twitter.vue';
